
namespace RioERP.Reports {
    export class B2CColumns {
        static columnsKey = 'Reports.B2C';
    }
}